import { useCallback } from "react";
import useFetch from "../../hooks/useFetch";
import { useShowMessage } from "../Common/showMessage";

function useGetPlates() {
  const [fetchWrapper] = useFetch();
  const showMessage = useShowMessage();

  const getPlates = useCallback(
    (resetPlates, transaction_id, setPlates) => {
      resetPlates();
      fetchWrapper({
        endpoint_url: "transaction/getTransactionDetails",
        params: {
          transaction_id: transaction_id,
        },
        onSuccess: (fetch_output) => {
          if (!("error" in fetch_output)) {
            let data = fetch_output["data"];
            setPlates(data);
          } else {
            showMessage({ message: "Failed to get plate items" });
          }
        },
        onFetchError: () =>
          showMessage({ apiType: "fetch", message: "Get Plates" }),
        onResponseError: () =>
          showMessage({ apiType: "response", message: "Get Plates" }),
      });
    },
    [fetchWrapper]
  );

  return { getPlates };
}

export default useGetPlates;
